import React from 'react'
import useAuthenticationStore, { AuthenticationViews } from './Store';
import { useConfiguration } from './Configuration';
import { getLinkKey } from '../utils';
import Login from './Login';

const LoginContainer: React.FC = () => {
  const { state, dispatch, startLogin } = useAuthenticationStore()
  const { project, emailOrPhone, serverError, clientErrors, isLoading } = state
  const { configuration } = useConfiguration()

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: "SET_EMAIL_OR_PHONE", payload: newEmailOrPhone })
  }

  return (
    <Login
      emailOrPhone={emailOrPhone}
      serverError={serverError}
      clientErrors={clientErrors}
      isLoading={isLoading}
      externalLoginLinks={configuration.externalLoginLinks}
      joinLink={(project?.AllowCodeEnrollment ?? true) || getLinkKey() ? "../" + AuthenticationViews.join : ""}
      startLogin={startLogin}
      setEmailOrPhone={setEmailOrPhone}
    />
  )
}

export default LoginContainer;